import { useRef, useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { userPaymentMethodErrorSelector } from '@hero/redux-data/backoffice/userPaymentMethod/selectors';
import { useNotifications } from '../../context/notification';
const useUserPaymentMethodUpdateFailAlert = () => {
    const { error, errorMessage } = useSelector(userPaymentMethodErrorSelector, shallowEqual);
    const { addNotification, removeNotification } = useNotifications();
    const id = useRef();
    useEffect(() => {
        id.current && removeNotification(id.current);
        if (error) {
            id.current = addNotification({
                type: 'fail',
                message: errorMessage || 'Error updating payment method.'
            });
        }
        else {
            id.current = undefined;
        }
    }, [addNotification, removeNotification, error, errorMessage]);
};
export default useUserPaymentMethodUpdateFailAlert;
